import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { CreateUserState, EMAIL_RE } from './useCreateUser';

/** Identity: names, the proposed login, the email. */
export const IdentitySection: React.FC<{ form: CreateUserState }> = ({ form }) => {
  const { t } = useI18n();
  const { errors, isLoading } = form;

  return (
    <section className="cu-section">
      <header className="cu-section-head">
        <h3>{t('users.create.stepIdentity')}</h3>
        <p>{t('users.create.identityIntro')}</p>
      </header>

      <div className="cu-grid">
        <div className="cu-field">
          <label htmlFor="cu-first">{t('users.firstName')} <span className="required-asterisk">*</span></label>
          <input id="cu-first" type="text" className={`cu-input${errors.firstName ? ' is-error' : ''}`} data-testid="field-user-first-name" value={form.firstName}
                 onChange={(e) => { form.setFirstName(e.target.value); form.clearError('firstName'); }}
                 onBlur={() => { if (!form.firstName.trim()) form.setFieldError('firstName', t('users.create.errFirstNameRequired')); }}
                 placeholder={t('users.firstNamePlaceholder')} disabled={isLoading} autoFocus maxLength={100} autoComplete="off" required />
          {errors.firstName && <span className="cu-error" role="alert">{errors.firstName}</span>}
        </div>
        <div className="cu-field">
          <label htmlFor="cu-last">{t('users.lastName')} <span className="required-asterisk">*</span></label>
          <input id="cu-last" type="text" className={`cu-input${errors.lastName ? ' is-error' : ''}`} data-testid="field-user-last-name" value={form.lastName}
                 onChange={(e) => { form.setLastName(e.target.value); form.clearError('lastName'); }}
                 onBlur={() => { if (!form.lastName.trim()) form.setFieldError('lastName', t('users.create.errLastNameRequired')); }}
                 placeholder={t('users.lastNamePlaceholder')} disabled={isLoading} maxLength={100} autoComplete="off" required />
          {errors.lastName && <span className="cu-error" role="alert">{errors.lastName}</span>}
        </div>
        <div className="cu-field">
          <label htmlFor="cu-username">{t('users.username')} <span className="required-asterisk">*</span></label>
          <div className="cu-input-row">
            <input
              id="cu-username" type="text" className={`cu-input mono${errors.username ? ' is-error' : ''}`} data-testid="field-user-username"
              value={form.username}
              onChange={(e) => { form.setUsername(e.target.value); form.setUsernameTouched(true); form.clearError('username'); }}
              onBlur={() => { const msg = form.usernameError(form.username); if (msg && form.username) form.setFieldError('username', msg); }}
              placeholder={t('users.create.usernamePlaceholder')} disabled={isLoading} maxLength={255} autoComplete="off" spellCheck={false}
            />
            {form.usernameTouched && (form.firstName || form.lastName) && (
              <button type="button" className="cu-link" onClick={() => { form.setUsernameTouched(false); form.clearError('username'); }} data-testid="cu-username-suggest">
                {t('users.create.usernameSuggest')}
              </button>
            )}
          </div>
          {errors.username ? <span className="cu-error" role="alert">{errors.username}</span> : <span className="cu-hint">{t('users.create.usernameHelp')}</span>}
        </div>
        <div className="cu-field">
          <label htmlFor="cu-email">{t('users.email')} <span className="required-asterisk">*</span></label>
          <input id="cu-email" type="email" className={`cu-input${errors.email ? ' is-error' : ''}`} data-testid="field-user-email" value={form.email}
                 onChange={(e) => { form.setEmail(e.target.value); form.clearError('email'); }}
                 onBlur={() => {
                   if (!form.email.trim()) form.setFieldError('email', t('users.create.errEmailRequired'));
                   else if (!EMAIL_RE.test(form.email)) form.setFieldError('email', t('users.create.errEmail'));
                 }}
                 placeholder={t('users.create.emailPlaceholder')} disabled={isLoading} autoComplete="off" required />
          {errors.email ? <span className="cu-error" role="alert">{errors.email}</span> : <span className="cu-hint">{t('users.create.emailHelp')}</span>}
        </div>
      </div>
    </section>
  );
};
